import { IS_CLOUD } from '@qality/common-config';
import { User } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

const PARAMETER = IS_CLOUD ? 'accountId' : 'userKey';

export type Property = {
  key: string;
  value: any;
};

export default {
  async getProperty(propertyName: string, user: User): Promise<Property> {
    const response = await StorageOfUniqueServices.get('API').noRetry({
      url: `/rest/api/2/user/properties/${propertyName}?${PARAMETER}=${user.getIdentifier()}`,
      type: 'GET',
    });

    return JSON.parse(response.body);
  },
  async setProperty(
    propertyName: string,
    propertyValue: any,
    user: User
  ): Promise<void> {
    await StorageOfUniqueServices.get('API').request({
      url: `/rest/api/2/user/properties/${propertyName}?${PARAMETER}=${user.getIdentifier()}`,
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(propertyValue),
    });
  },
};
